/**
 * Service-worker registration. The worker itself is generated at build time
 * by vite-plugin-pwa (Workbox precache of every built asset), which is what
 * makes the game fully playable offline. In dev the virtual module is a
 * no-op shim.
 */
export function registerPwa(): void {
  if (!('serviceWorker' in navigator)) return
  // virtual module provided by vite-plugin-pwa
  import('virtual:pwa-register')
    .then(({ registerSW }) => registerSW({ immediate: true }))
    .catch(() => {
      /* dev server without PWA — offline support only matters in builds */
    })
}
